import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';
import { Precision } from '/@/modules/core/form/models/Precision';

export class Step144263Meta extends BaseModel {
  /**
   * @var {bool}
   */
  hasValuables;

  /**
   * @var {?array}
   */
  valuableTypes;

  /**
   * @var {?Object}
   */
  precisions;

  constructor(model = {}) {
    super();
    this.hasValuables = model.hasValuables;
    this.valuableTypes = model.valuableTypes ?? [];
    this.precisions = Precision.mapModels(model.precisions);
  }
}
